module.exports = __webpack_public_path__ + "static/media/thewest-tape-black-friday-1.e7029a2b.png";